import script from "./FinanceSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./FinanceSection.vue?vue&type=script&lang=ts&setup=true"

import "./FinanceSection.vue?vue&type=style&index=0&id=6ee66b37&scoped=true&lang=css"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee66b37"]])

export default __exports__